import { useTranslation } from "react-i18next";

const FadeAnother = () => {
  const { t } = useTranslation();
  return (
    <div
      className="main__content"
      id="main__content__v1"
      style={{
        backgroundColor: "rgba(242,242,242,1)",
      }}
    >
      <div
        className="item2"
        style={{
          backgroundColor: "rgba(242,242,242,1)",
        }}
      >
        <div id="fade_another_photo">
          <img id="img__sample" src="/assets/images/sample.svg" />
        </div>
      </div>

      <div
        className="item4"
        style={{
          backgroundColor: "rgba(242,242,242,1)",
        }}
      >
        <div id="fade_another_text">
          <div id="fade__another_title">{t("fade__another_title")}</div>
          <div className="text__content" id="fade__another_content">
            <p>
              <span>
                {t("fade__another_content_1")}{" "}
                <strong>{t("fade__another_content_2")}</strong>
              </span>
              {t("fade__another_content_3")}
              <br /> {t("fade__another_content_4")}{" "}
              <strong>{t("fade__another_content_5")}</strong>
              {t("fade__another_content_6")}
            </p>
            <p>
              {t("fade__another_content_7")}
              <br />
              <strong>{t("fade__another_content_8")}</strong>
              {t("fade__another_content_9")}
            </p>
            <p>
              {t("fade__another_content_10")}
              <br /> {t("fade__another_content_11")}
              <br /> {t("fade__another_content_12")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FadeAnother;
